import { Extra } from "./Extra";
import * as THREE from "three";
import { MathUtils, Vector2 } from "three";
import { envMap, glassAlpha, glassNormal, pillarColorGray, sliderNormal, wallRoughness } from "../../assets/materials";
import { ExtraType } from "../../../entities/LedExtras";
var degToRad = MathUtils.degToRad;
export class GlassPanels extends Extra {
    /** Creates the glass sides according to the user's choice **/
    createPanel() {
        if (this.formData.left.extra === ExtraType.GLASS || this.formData.left.extra === ExtraType.GLASS_ZIPSCREEN) {
            // LEFT blue
            this.createGlassFrames(this.dimension.left, "LEFT", 200);
        }
        if (this.formData.right.extra === ExtraType.GLASS || this.formData.right.extra === ExtraType.GLASS_ZIPSCREEN) {
            //RIGHT Green
            this.createGlassFrames(this.dimension.right, "RIGHT", 100);
        }
        if (this.formData.close.extra === ExtraType.GLASS || this.formData.close.extra === ExtraType.GLASS_ZIPSCREEN) {
            // CloseSide - WHITE
            this.createGlassFrames(this.dimension.close, "CLOSE", 400);
        }
        if (this.formData.far.extra === ExtraType.GLASS || this.formData.far.extra === ExtraType.GLASS_ZIPSCREEN) {
            // WALL Purple
            this.createGlassFrames(this.dimension.far, "FAR", 300);
        }
    }
    /** The space between 2 leg is 1 frame here. Usually 1 module means 1 frame however if the width is more than 600 or in PVC 450 and 900 there is another frame inside a module
     * We get the frame from the side object automatically
     * We get the frameSize then we call the calculatePanelNumbers method which will get the glass panel sizes and count.
     * **/
    createGlassFrames(side, name, order) {
        // When we have walls return
        if (this.scene.getActualSide(name).wall === true) {
            return;
        }
        let rotation = side.rotationY;
        const scale = new THREE.Vector3(1, 1, 1);
        const quatRotation = new THREE.Quaternion(0, 0, 0);
        const pos = side.position;
        // Remove the pillar's width from the frame sizes
        let width = side.length - this.formData.measuredModel.model.edgeWidth * 2 - this.formData.measuredModel.model.edgeWidth * (side.frames - 1);
        let startingPos = pos.x - width / 2 - this.formData.measuredModel.model.edgeWidth / 2 * (side.frames - 1);
        let startingPosZ = pos.z - width / 2 - this.formData.measuredModel.model.edgeWidth / 2 * (side.frames - 1);
        const frameSize = width / side.frames;
        let panelNumber = this.calculatePanelNumbers(frameSize);
        let glassSize = panelNumber[1];
        const mat = this.scene.materialPicker.getMaterial();
        mat.alphaMap = glassAlpha;
        mat.transparent = true;
        mat.normalMap = glassNormal;
        mat.roughness = 0.1;
        mat.envMap = envMap;
        mat.envMapIntensity = 0.4;
        const sideMat = new THREE.MeshBasicMaterial({ color: 0x181818 });
        const glassMaterials = [
            sideMat,
            sideMat,
            sideMat,
            sideMat,
            mat,
            mat,
        ];
        // Glass geometry
        for (let x = 0; x < side.frames; x++) {
            const geom = new THREE.BoxGeometry(glassSize, 240, 2).rotateY(degToRad(rotation));
            let mainPos = startingPos + frameSize * x + this.scene.formData.measuredModel.model.edgeWidth * x;
            let mainPosZ = startingPosZ + frameSize * x + this.scene.formData.measuredModel.model.edgeWidth * x;
            // Using instaced mesh for every frame TODO 1 instance mesh for the whole side
            const mesh = new THREE.InstancedMesh(geom, glassMaterials, panelNumber[0]);
            for (let i = 0; i < panelNumber[0]; i++) {
                let position;
                if (rotation === 0)
                    position = new THREE.Vector3(mainPos + glassSize / 2 + glassSize * i, pos.y, pos.z + (panelNumber[0]) - 2 * i);
                else
                    position = new THREE.Vector3(pos.x + (panelNumber[0]) - 2 * i, pos.y, mainPosZ + glassSize / 2 + glassSize * i);
                mesh.setMatrixAt(i, new THREE.Matrix4().compose(position, quatRotation, scale));
            }
            mesh.renderOrder = order - x;
            this.scene.threeScene.add(mesh);
        }
        // Slider part
        const colorRepeat = new Vector2(length / 1024 * 24, 30 / 1024 * 24);
        let textureRepeat = new Vector2(0.002, 0.002);
        const sliderNormalMap = new THREE.Texture();
        const sliderColor = new THREE.Texture();
        sliderColor.repeat = colorRepeat;
        sliderNormalMap.repeat = textureRepeat;
        this.scene.assignTexture(sliderNormalMap, sliderNormal);
        this.scene.assignTexture(sliderColor, pillarColorGray);
        const sliderFrontMat = new THREE.MeshStandardMaterial({
            map: sliderColor,
            normalMap: sliderNormalMap,
            metalness: 1.0,
            roughnessMap: wallRoughness,
        });
        const sliderOtherMat = new THREE.MeshBasicMaterial({
            color: 0x181818
        });
        const materials = [
            sliderOtherMat,
            sliderOtherMat,
            sliderFrontMat,
            sliderOtherMat,
            sliderOtherMat,
            sliderOtherMat,
        ];
        this.createSlider(side, materials);
    }
    createSlider(side, mat) {
        const geom = new THREE.BoxGeometry(side.length + 2, 5, this.formData.measuredModel.model.edgeWidth);
        const mesh = new THREE.Mesh(geom, mat);
        mesh.position.copy(side.position);
        mesh.rotateY(degToRad(side.rotationY));
        mesh.position.y = 10;
        this.scene.threeScene.add(mesh);
    }
    calculatePanelNumbers(width) {
        if (width < 225) {
            return [2, width / 2];
        }
        else {
            let closestNumber = 100;
            let c2 = 100;
            for (let i = 75; i <= 100; i += 0.1) {
                let c1 = width % i;
                if (c2 > c1) {
                    c2 = c1;
                    closestNumber = i;
                }
            }
            return [Math.round(width / closestNumber), closestNumber];
        }
    }
}
